import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  constructor(private dateFormatter: DatePipe) {

  }

  transform($event: any, ...args: unknown[]): string | null {
    if ($event.detail) {
      let dateValue = new Date($event.detail.year, $event.detail.month, $event.detail.date);
      let formattedDate = this.dateFormatter.transform(dateValue, 'yyyy-MM-dd', undefined, 'en-US');
      return formattedDate;
    }
    return null;
  }
}
